module.exports = __webpack_public_path__ + "img/1200796566.754bb052.jpg";